import { useContext } from 'react'
import { PlansTrendsContext } from '../Contexts/PlansTrendsContext'

export function usePlansTrends() {
    return useContext(PlansTrendsContext)
}
